var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.80005,
    y: 1.2,
    width: 25,
    height: 25,
    rx: 9,
    fill: "#00875A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5276 12.5316C9.88353 11.8875 8.83928 11.8875 8.19521 12.5316C7.55114 13.1756 7.55114 14.2199 8.19521 14.8639L11.4937 18.1624C12.1378 18.8065 13.182 18.8065 13.8261 18.1624L20.4231 11.5654C21.0672 10.9214 21.0672 9.87713 20.4231 9.23306C19.779 8.58898 18.7348 8.58898 18.0907 9.23306L12.6599 14.6639L10.5276 12.5316Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.80005,
    y: 1.2,
    width: 25,
    height: 25,
    rx: 9,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.9089fb3cf6aa1bfdd9258e84c076c542.svg";
export { ForwardRef as ReactComponent };